module.exports = __webpack_public_path__ + "static/media/HND.2c1b8731.svg";


//////////////////
// WEBPACK FOOTER
// ./src/HND.svg
// module id = 27
// module chunks = 0